import React from "react";
import "./SkeletonStyle/SkeletonStyle.css";

export const BudgetSkeleton = () => {
  return (
    <div style={{ display: "flex", width: "100%", gap: "1rem" }}>
      {/* Simulation of the Left Column (30%) - reportCard1 */}
      <div style={{ width: "30%", display: "flex", flexDirection: "column", gap: "1rem" }}>
        {/* The Dark Blue Card Skeleton */}
        <div 
          className="skeleton" 
          style={{ 
            height: "400px", 
            backgroundColor: "#2a3da3", 
            opacity: "0.8",
            borderRadius: "12px",
            padding: "1rem"
          }}
        >
          <div className="skeleton" style={{ width: "50%", height: "20px", backgroundColor: "rgba(255,255,255,0.2)" }}></div>
          <div className="skeleton" style={{ width: "80%", height: "150px", backgroundColor: "rgba(255,255,255,0.1)", margin: "2rem auto" }}></div>
          <div className="skeleton" style={{ width: "40%", height: "20px", backgroundColor: "rgba(255,255,255,0.2)" }}></div>
        </div>
        
        {/* Lower Transaction Skeleton on Left */}
        <div className="skeleton" style={{ height: "300px", borderRadius: "12px", backgroundColor: "#f4f7fe" }}></div>
      </div>

      {/* Simulation of the Right Column (70%) - reportCard2 */}
      <div className="skeleton" style={{ width: "70%", height: "716px", borderRadius: "12px", backgroundColor: "#fff", padding: "1.5rem" }}>
         <div className="skeleton" style={{ width: "30%", height: "30px", marginBottom: "2rem", backgroundColor: "#eee" }}></div>
         
         {/* Multiple rows for budget categories */}
         {[1, 2, 3, 4, 5].map((i) => (
           <div key={i} style={{ display: "flex", gap: "1rem", marginBottom: "1.5rem" }}>
             <div className="skeleton" style={{ width: "80px", height: "80px", borderRadius: "12px", backgroundColor: "#eee" }}></div>
             <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", gap: "0.8rem" }}>
                <div className="skeleton" style={{ width: "40%", height: "20px", backgroundColor: "#eee" }}></div>
                <div className="skeleton" style={{ width: "100%", height: "10px", backgroundColor: "#eee", borderRadius: "5px" }}></div>
                <div className="skeleton" style={{ width: "20%", height: "15px", backgroundColor: "#eee" }}></div>
             </div>
           </div>
         ))}
      </div>
    </div>
  );
};
